import React from "react"
import { Button } from "@material-ui/core"
import Drawer from 'components/shared/Drawer'

const formatDate = (dateStr) => {
    if (!dateStr) return ''
    try {
        return new Date(dateStr).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
    } catch {
        return dateStr
    }
}

const formatDateTime = (dateStr) => {
    if (!dateStr) return ''
    const date = new Date(dateStr)
    if (isNaN(date)) return dateStr
    return date.toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' })
}

const ENTITY_TYPES = { BUSINESS: 'Business', BUSINESS_DBA: 'Business (DBA)', CONNECTED_BUSINESS: 'Connected business', OWNER: 'Owner' }

const BgvReportHistoryDrawer = ({ open, onClose, reportHistory, onSelectReport, onDownloadPdf }) => {

    const getLabel = (report, index) => {
        const date = report.saveDate || report.createdAt
        if (index === 0) return date ? `Current report, ${formatDateTime(date)}` : 'Current report'
        return date ? `Report from ${formatDateTime(date)}` : 'Previous report'
    }

    return (
        <Drawer open={open} onClose={onClose} title="Report History">
            <div className="p-3">
                {reportHistory.length === 0 && <p>No previous reports found.</p>}
                {reportHistory.map((report, index) => (
                    <div
                        key={report.backgroundReportStatusUuid}
                        className={`p-2 mb-2 border rounded ${index === 0 ? 'border-primary' : ''}`}
                    >
                        <div className="d-flex justify-content-between align-items-center">
                            <strong>{report.name}</strong>
                            <span className={`text-muted ${index === 0 ? 'font-weight-bold' : ''}`}>
                                {getLabel(report, index)}
                            </span>
                        </div>
                        <div className="text-muted small">
                            {ENTITY_TYPES[report.entityType] || report.entityType}
                            {report.requestedBy ? ` | Requested by: ${report.requestedBy}` : ''}
                        </div>
                        <div className="mt-2 d-flex">
                            <Button
                                size="small"
                                color="primary"
                                variant="outlined"
                                onClick={() => onSelectReport(report)}
                                className="mr-2"
                            >
                                View Report
                            </Button>
                            {report.pdfReportUuid && onDownloadPdf && (
                                <Button
                                    size="small"
                                    variant="outlined"
                                    onClick={() => onDownloadPdf(report.pdfReportUuid, `backgroundReport-${formatDate(report.saveDate || report.createdAt)}.pdf`)}
                                >
                                    Download PDF
                                </Button>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </Drawer>
    )
}

export default BgvReportHistoryDrawer